module.exports = __webpack_public_path__ + "Ubuntu-MediumItalic.0fbe070c207e3a869cc9.ttf";


//////////////////
// WEBPACK FOOTER
// D:/F210-INGRESO/cambio_enlace_ayuda/rec_ng_ingresorenta210/src/assets/fonts_v2/Ubuntu/Ubuntu-MediumItalic.ttf
// module id = ../../../../../src/assets/fonts_v2/Ubuntu/Ubuntu-MediumItalic.ttf
// module chunks = styles